import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Tooltip } from 'primereact/tooltip';

function TooltipHeader(props) {
  if (!props.tooltip) {
    return null;
  }
  return jsxs(Fragment, {
    children: [jsx(Tooltip, {
      target: "#panel-tooltip-title"
    }), jsx("span", {
      id: "panel-tooltip-title",
      "data-pr-position": "left",
      "data-pr-tooltip": props.tooltip,
      children: props.header
    })]
  });
}

export { TooltipHeader };
